import { Box, Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { esaFundsLoggedOutBannerCtaPath } from "@outschool/routes";
import { ExternalLink, TrackedButton } from "@outschool/ui-components-shared";
import { Container } from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

const TRACKING_LABEL = "esa_funds_banner_cta";

function PromotionBanner(
  {
    isFullWidth = false,
  }: {
    isFullWidth?: boolean;
  },
  ref: React.Ref<HTMLDivElement>
): JSX.Element {
  const isMobile = useIsMobile();
  const { t } = useTranslation(
    "ui-components-website\\Banners\\PromotionBanner"
  );

  return (
    <Container ref={ref} fullBleed={isMobile || isFullWidth}>
      <Box
        flex
        sx={(theme: Theme) => ({
          flexDirection: "column",
          alignItems: "center",
          background: theme.gradients?.primarySecondary,
          borderRadius: 0,

          [theme.breakpoints.up("md")]: {
            borderRadius: "1em",
          },
        })}
      >
        <Box
          flex
          sx={(theme: Theme) => ({
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            paddingTop: 60,
            paddingBottom: 48,
            paddingX: "1em",

            [theme.breakpoints.up("md")]: {
              paddingX: "3em",
            },

            maxWidth: 800,
          })}
        >
          <Typography variant="h3" emphasized>
            {t("Use your ESA funds on Outschool")}
          </Typography>

          <Box
            sx={{
              marginTop: 20,
              marginBottom: 28,
            }}
          >
            {t(
              "ESA-eligible families can now use their Education Savings Accounts to customize their learning."
            )}
          </Box>

          <TrackedButton
            variant="contained"
            component={ExternalLink}
            url={esaFundsLoggedOutBannerCtaPath()}
            trackingName={TRACKING_LABEL}
            trackingUniqueId={TRACKING_LABEL}
            sx={(theme: Theme) => ({
              width: "100%",

              [theme.breakpoints.up("md")]: {
                width: "auto",
              },
            })}
          >
            {t("Learn How It Works")}
          </TrackedButton>
        </Box>
      </Box>
    </Container>
  );
}

export default React.forwardRef(PromotionBanner);
